import templateUrl from './cartCallout.html';

export function CartCalloutDirective(){
    return {
        replace: true,
        templateUrl,
        link: function(){

        }
    };
}
